<script setup>
import { ref } from "vue";

defineProps({
    defaultImage: {
        type: String,
        required: true,
    },
    hoveredImage: {
        type: String,
        required: true,
    },
    defaultAlt: {
        type: String,
        default: "",
    },
    hoveredAlt: {
        type: String,
        default: "",
    },
    defaultHref: {
        type: String,
        default: "#",
    },
    logoSize: {
        type: String,
        default: "w-full h-7 sm:h-8",
    },
    transitionClass: {
        type: String,
        default: "transition duration-100 ease-in-out transform",
    },
});

const isHovered = ref(false);

const toggleHover = () => {
    isHovered.value = !isHovered.value;
};
</script>

<template>
    <a
        :href="defaultHref"
        target="_blank"
        @mouseenter="toggleHover"
        @mouseleave="toggleHover"
    >
        <img
            :src="isHovered ? hoveredImage : defaultImage"
            :alt="isHovered ? hoveredAlt : defaultAlt"
            :class="[logoSize, transitionClass]"
        />
    </a>
</template>
